import React from "react";
import { Navigate } from "react-router-dom";

const AgentRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("authenticated") === "true";
  const role = localStorage.getItem("role");

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (role !== "agent") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AgentRoute;